import type { LayerSection } from 'features/mapping/mapping.types';

import GeneralSectionIcon from './general.svg?react';
import WeatherSectionIcon from './weather.svg?react';
import FloodSectionIcon from './flood.svg?react';
import ProfessionalSectionIcon from './professional.svg?react';
import TeamSectionIcon from './team.svg?react';

import {
  createSvgLayerSectionIcon,
  type LayerSectionIconComponent,
} from './createLayerSectionIcon';

export type { LayerSectionIconProps } from './LayerSectionIcon.types';
export type { LayerSectionIconComponent };

export const LAYER_SECTION_ICONS: Record<
  LayerSection,
  LayerSectionIconComponent
> = {
  general: createSvgLayerSectionIcon(GeneralSectionIcon),
  weather: createSvgLayerSectionIcon(WeatherSectionIcon),
  flood: createSvgLayerSectionIcon(FloodSectionIcon),
  professional: createSvgLayerSectionIcon(ProfessionalSectionIcon),
  team: createSvgLayerSectionIcon(TeamSectionIcon),
};
